import { render, staticRenderFns } from "./ModalVisualizarConsentimento.vue?vue&type=template&id=db061552&scoped=true"
import script from "./ModalVisualizarConsentimento.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarConsentimento.vue?vue&type=script&lang=js"
import style0 from "./ModalVisualizarConsentimento.vue?vue&type=style&index=0&id=db061552&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db061552",
  null
  
)

export default component.exports